import { observer } from 'mobx-react-lite';
import AttendanceStore from '../AttendanceStore';

import MyArea from '../MyArea';
import { Box, Button, Grid, useTheme } from '@mui/material';
import QueueDisplayHeader from './QueueDisplayHeader';
import QueueEntryCard from './QueueEntryCard';
import MyAlertDialog from 'Alert/MyAlertDialog';

type QueueDisplayPropsT = {
  attendanceStore: AttendanceStore;
};

const QueueDisplay = observer(({ attendanceStore }: QueueDisplayPropsT) => {
  console.log('AttLog render');

  const { payloadQueue } = attendanceStore;
  const { palette } = useTheme();
  const isQueueEmpty = payloadQueue.length === 0;

  const handleSoundTestClick = async () => {
    await attendanceStore.speakStore.testSound();
  };

  return (
    <MyArea width="full">
      <QueueDisplayHeader
        onCloseBtnClick={() => attendanceStore.setViewMode('form')}
      />
      <Box
        flex={1}
        sx={{
          background: palette.background.paper,
        }}
      >
        {isQueueEmpty ? (
          <Box
            sx={{
              height: '100%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <Button variant="contained" onClick={handleSoundTestClick}>
              소리 테스트
            </Button>
          </Box>
        ) : (
          <Grid container p={2} spacing={1} sx={{}}>
            {payloadQueue.map((entry) => (
              <Grid
                key={entry.firedAt.toISOString() + entry.student.id}
                item
                xs={12}
                sm={12}
                md={4}
                lg={3}
              >
                <QueueEntryCard entry={entry} />
              </Grid>
            ))}
          </Grid>
        )}
      </Box>
      <MyAlertDialog store={attendanceStore.myAlertStore} />
    </MyArea>
  );
});

export default QueueDisplay;
